import {
  Button,
  TextControl,
  TextareaControl,
  SelectControl,
  Placeholder,
  PanelBody,
  PanelRow,
  TextHighlight,
  ToggleControl,
} from '@wordpress/components';
import {
  MediaUpload,
  MediaUploadCheck,
  useBlockProps,
  InspectorControls,
} from '@wordpress/block-editor';
import { useState } from '@wordpress/element';

export default function Edit({ attributes, setAttributes }) {
  const { slides, padding, title, positiontitle, url, colorbg, container } =
    attributes;
  const [isVisibleBlock, setIsVisibleBlock] = useState(false);
  // Инициализация слайдов, если их нет
  const initSlides =
    slides && slides.length > 0
      ? slides
      : [
          {
            id: 1,
            image: {},
            title: 'Блок 1',
            description: 'Описание',
            url: '',
          },
        ];

  // Добавление нового слайда
  const addSlide = () => {
    const newId = initSlides.length + 1;
    const newSlide = {
      id: newId,
      image: {},
      title: `Блок ${newId}`,
      description: '',
      url: '',
    };
    setAttributes({ slides: [...initSlides, newSlide] });
  };

  // Удаление слайда
  const removeSlide = (slideId) => {
    if (initSlides.length <= 1) {
      alert('Должен быть хотя бы один слайд');
      return;
    }
    const updatedSlides = initSlides.filter((slide) => slide.id !== slideId);
    setAttributes({ slides: updatedSlides });
  };

  // Обновление данных слайда
  const updateSlide = (slideId, field, value) => {
    const updatedSlides = initSlides.map((slide) => {
      if (slide.id === slideId) {
        return { ...slide, [field]: value };
      }
      return slide;
    });

    setAttributes({ slides: updatedSlides });
  };

  const blockProps = useBlockProps({
    className: 'custom-slider',
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title="Настройки блока" initialOpen={true}>
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Заголовок блока"
            value={title}
            onChange={(value) => setAttributes({ title: value })}
            placeholder="Введите текст"
          />
          {title && (
            <SelectControl
              __next40pxDefaultSize
              __nextHasNoMarginBottom={true}
              label="Положение заголовка"
              value={positiontitle}
              options={[
                { label: 'Слева', value: '' },
                { label: 'По центру', value: 'justify-content-center' },
              ]}
              onChange={(value) => setAttributes({ positiontitle: value })}
            />
          )}
          <TextControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Ссылка в блоке"
            value={url}
            onChange={(value) => setAttributes({ url: value })}
            type="url"
            placeholder="Введите url"
          />
          <SelectControl
            __next40pxDefaultSize
            __nextHasNoMarginBottom={true}
            label="Отступы блока"
            value={padding}
            options={[
              { label: 'Без отступа', value: '' },
              { label: 'Сверху', value: 'pt-5' },
              { label: 'Снизу', value: 'pb-5' },
              { label: 'Сверху и снизу', value: 'py-5' },
            ]}
            onChange={(value) => setAttributes({ padding: value })}
          />
          <ToggleControl
            __nextHasNoMarginBottom={true}
            label="Серый фон"
            checked={colorbg}
            onChange={(value) => setAttributes({ colorbg: value })}
          />
          <ToggleControl
            __nextHasNoMarginBottom={true}
            label="Отключить контейнер"
            help="Нужен для отключения лишних отступов"
            checked={container}
            onChange={(value) => setAttributes({ container: value })}
          />
        </PanelBody>
      </InspectorControls>
      <div {...blockProps}>
        <div className="custom-slider__container">
          <div
            onClick={() => setIsVisibleBlock(!isVisibleBlock)}
            className="custom-slider__title"
          >
            {title ? title : 'Каталог камня'}
          </div>
          {isVisibleBlock && (
            <div className="custom-slider__wrap">
              <div className="custom-slider__slides">
                {initSlides.map((slide) => (
                  <div key={slide.id} className="custom-slider__slide">
                    <div className="custom-slider__slide-header">
                      <h3>Блок #{slide.id}</h3>
                      <div className="custom-slider__slide-actions">
                        <Button
                          onClick={() => removeSlide(slide.id)}
                          variant="secondary"
                          isDestructive
                        >
                          Удалить
                        </Button>
                      </div>
                    </div>
                    <div className="custom-slider__flex">
                      <div className="custom-slider__image-wrapper">
                        <MediaUploadCheck>
                          <MediaUpload
                            onSelect={(media) => {
                              updateSlide(slide.id, 'image', media);
                            }}
                            allowedTypes={['image']}
                            value={slide.image.id}
                            render={({ open }) => (
                              <div className="custom-slider__image-container">
                                {slide.image.url ? (
                                  <div className="custom-slider__image-preview">
                                    <img
                                      src={slide.image.url}
                                      alt={slide.image.alt}
                                    />
                                    <Button
                                      onClick={() => {
                                        updateSlide(slide.id, 'image', '');
                                      }}
                                      className="custom-slider__remove-image"
                                      variant="primary"
                                    >
                                      Удалить изображение
                                    </Button>
                                  </div>
                                ) : (
                                  <Button
                                    onClick={open}
                                    className="custom-slider__add-image"
                                    variant="secondary"
                                  >
                                    Выбрать изображение
                                  </Button>
                                )}
                              </div>
                            )}
                          />
                        </MediaUploadCheck>
                      </div>

                      <div className="custom-slider__content-wrapper">
                        <TextControl
                          value={slide.title}
                          onChange={(value) =>
                            updateSlide(slide.id, 'title', value)
                          }
                          placeholder="Введите заголовок"
                        />

                        <TextControl
                          value={slide.url}
                          onChange={(value) =>
                            updateSlide(slide.id, 'url', value)
                          }
                          placeholder="Введите url"
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {initSlides.length < 9 && (
                <Button
                  onClick={addSlide}
                  variant="primary"
                  className="custom-slider__add-slide"
                >
                  + Добавить блок
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
